export const distanceInWords = distanceInMeters => {
    const feet = Math.round(distanceInMeters * 3.2808);
    if (feet < 1320) {
        return `${feet} feet`;
    }
    if (feet < 2000) {
        return '1/4 mile';
    }
    if (feet < 3400) {
        return 'About 1/2 mile';
    }
    if (feet < 4500) {
        return 'About 3/4 mile';
    }
    if (feet < 6000) {
        return '1 mile';
    }
    const miles = feet / 5280;
    return `${miles.toFixed(1)} miles`;
};

export const durationInWords = durationInSeconds => {
    let durationText = '';
    let minutes = Math.floor(durationInSeconds/60);
    const hours = Math.floor((durationInSeconds/60)/60);
    if (durationInSeconds < 60) {
        return 'less than a minute';
    }
    if (hours > 0) {
        minutes = minutes - (hours * 60);
        durationText += `${hours} hr `;
    }
    if (minutes !== 0) {
        durationText += `${minutes} min`;
    }
    return durationText;
};